import { render } from "./CaseDocumentCard.vue?vue&type=template&id=44193f48&scoped=true"
import script from "./CaseDocumentCard.vue?vue&type=script&lang=js"
export * from "./CaseDocumentCard.vue?vue&type=script&lang=js"

import "./CaseDocumentCard.vue?vue&type=style&index=0&id=44193f48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44193f48"]])

export default __exports__